const TWO_FACTOR_CODE_REQUIRED = 'e_two_factor_code_required';
const TWO_FACTOR_CODE_EXPIRED = 'e_two_factor_code_expired';
const FORBIDDEN_ACTION = 'e_unauthorized_access';

export {
    TWO_FACTOR_CODE_REQUIRED,
    TWO_FACTOR_CODE_EXPIRED,     
    FORBIDDEN_ACTION
}
